import React, { useEffect, useRef, useState } from 'react'
import { CalendarOutlined } from '@ant-design/icons';
import { Grid } from '@material-ui/core';
import { Button, Card, Col, Row } from 'antd';
import DetailItem from '../../../../../CSIComponents/DetailItem';
import ApplicalbeDays from '../../../../../CSIComponents/ApplicalbeDays';
import PageContainer from '../../../../../CSIComponents/PageContainer';
const AMOUNT = 'Amount';
const PERCENT = 'Percent';
const NIGHTS = 'Nights';

const DetailDetails = (props: any) => {
  props.cancellationDetails.valueList = [
    { title: 'Mon', label: 'monday', value: props.cancellationDetails.monday === 'true' ? true : false },
    { title: 'Tue', label: 'tuesday', value: props.cancellationDetails.tuesday === 'true' ? true : false },
    { title: 'Wed', label: 'wednesday', value: props.cancellationDetails.wednesday === 'true' ? true : false },
    { title: 'Thu', label: 'thursday', value: props.cancellationDetails.thursday === 'true' ? true : false },
    { title: 'Fri', label: 'friday', value: props.cancellationDetails.friday === 'true' ? true : false },
    { title: 'Sat', label: 'saturday', value: props.cancellationDetails.saturday === 'true' ? true : false },
    { title: 'Sun', label: 'sunday', value: props.cancellationDetails.sunday === 'true' ? true : false },
  ]
  const rowDetail = JSON.parse(JSON.stringify(props.cancellationDetails))
  const [detailData, setDetailData] = useState<Array<any>>([])

  const applicalbeDaysRef = useRef()

  const getCharge = () => {
    let charge: Array<any> = []
    if (rowDetail.chargetype === AMOUNT) {
      charge = [{ label: 'Charge (Amount)', value: rowDetail.chargeamount, span: 6 },
                { label: 'Currency', value: rowDetail.currency, span: 6 },
                { span: 6 }]
    } else if (rowDetail.chargetype === PERCENT) {
            charge = [{ label: 'Charge (Percent)', value: rowDetail.chargepercent, span: 6 },
                      { span: 6 },
                      { span: 6 }]
    } else if (rowDetail.chargetype === NIGHTS) {
      charge = [{ label: 'Charge (Night)', value: rowDetail.chargenights, span: 6 },
                { span: 6 },
                { span: 6 }]
    }
    return charge
  }


  let _detailData = [
    { label: 'Guarantee Payment Policy Name', value: rowDetail.policyname, span: 6 },
    { label: 'Policy Code', value: rowDetail.policycode, span: 6 },
    { label: 'Policy Type', value: rowDetail.policytype, span: 6 },
    { span: 5 },
    { label: 'Guarantee Type', value: rowDetail.guaranteetype, span: 6 },
    { label: 'date', span: 12 },
    { label: 'applicalbeDaysoftheWeek', span: 12 },
    { span: 12 },
    { label: 'Applies to Room Type Code', value: rowDetail.roomtypecode, span: 6 },
    { span: 17 },
    { label: 'Descript', span: 18 },
    { label: 'Non-Refundable', value: rowDetail.nonrefundable, span: 6 },
    //{ label: 'Hold Time', value: typeof rowDetail.holdtime === 'object' ? moment(rowDetail.holdtime).format(formatTime) : rowDetail.holdtime, span: 6 }, //moment(detailsValue.holdtime).format(formatTime) || ''
    { label: 'Hold Time', value: rowDetail.holdtime, span: 6 }, //moment(detailsValue.holdtime).format(formatTime) || ''
    { label: 'Retribution', value: rowDetail.retribution, span: 6 },
    { span: 5 },
    { label: 'Charge Type', value: rowDetail.chargetype, span: 6 },
    // { label: `Chargeeeeeee (${rowDetail.chargetype || ''})`, value: rowDetail.chargeamount && parseFloat(rowDetail.chargeamount), span: 6 },
    ...getCharge(),
    // { label: 'Time Unit', value: rowDetail.currency, span: 6 },
    { label: 'Time Unit', value: rowDetail.timeunit, span: 6 },
    { label: 'Number of Units', value: rowDetail.noofunits, span: 6 },
    { label: 'Calculate Method', value: rowDetail.calculationmethod, span: 6 },
    { span: 5 },
  ]

  useEffect(() => {
    // if (rowDetail.chargetype === AMOUNT) {
    //   _detailData[17] = { label: 'Charge (Amount)', value: rowDetail.chargeamount, span: 6 }
    //   _detailData[18] = { label: 'Currency', value: rowDetail.currency, span: 6 }
    //   _detailData[19] = { span: 6 }
    // } else if (rowDetail.chargetype === PERCENT) {
    //   _detailData[17] = { label: 'Charge (Percent)', value: rowDetail.chargepercent, span: 6 }
    //   _detailData[18] = { span: 6 }
    //   _detailData[19] = { span: 6 }
    // } else if (rowDetail.chargetype === NIGHTS) {
    //   _detailData[17] = { label: 'Charge (Night)', value: rowDetail.chargenights, span: 6 }
    //   _detailData[18] = { span: 6 }
    //   _detailData[19] = { span: 6 }
    // }
    setDetailData(_detailData)
  }, 
  // eslint-disable-next-line react-hooks/exhaustive-deps 
  [])
  
  return <><PageContainer>
    <Card style={{ marginTop: -15 }}>
      <Grid container spacing={0} className="containerSpacing py-0">
        <Grid item xs={12} className="p-0">
          <div style={{ display: 'flex', justifyContent: 'space-between' }}>
            <div style={{ fontWeight: 600, fontSize: 14, color: '#333' }}>{rowDetail.policyname}</div>
            <div style={{ display: 'flex', justifyContent: 'flex-end' }}>
                    <div style={{margin: '0 10px 0 0'}}>
                        <Button className="db-edit-btn" onClick={() => { props.changeTab('GuaranteePayment') }}>Back</Button>
                    </div>
                    <div>
                      <Button className="db-edit-btn" onClick={() => { props.setActiveTabKey('Detail'); props.toggleToEditMode(); }}>Edit</Button>
                    </div>
              </div>
          </div>
        </Grid>
        <Grid item xs={12} className="pb-0 px-0 my-0">
          <Row gutter={24}>
            {
              detailData.map((item: any, i) => {
                return item.label === 'Descript' ? rowDetail.descriptions.map((desc: any, index: number) => {
                  return <React.Fragment key={'' + i + index}><Col span={item.span} className="col-margin">
                    <DetailItem value={desc.text} label={'Description' + (index + 1)} />
                  </Col><Col span={5}></Col></React.Fragment>
                }) : item.label === 'date' ? <Col span={item.span} key={i} className="col-margin">
                  <div style={{ display: 'inline-block', width: '100%' }}>
                    <div style={{ fontSize: 12, color: '#999999', height: '24px', "fontWeight": 600 }}>Start Date ~ End Date</div>
                    <div style={{ display: 'flex', width: '100%', textOverflow: 'ellipsis', borderBottom: '1px solid #CCCCCC', padding: '0 5px', fontSize: '14px', height: '32px', marginTop: '5px', lineHeight: '32px', overflow: 'hidden', color: '#333333' }}>
                      <div style={{ flex: 1 }}>{rowDetail.startdate}</div>
                      <span style={{ padding: '0 5px', marginLeft: -10 }}>~</span>
                      <div style={{ flex: 1 }}>{rowDetail.enddate}
                        <CalendarOutlined style={{ float: 'right', marginTop: 10 }} />
                      </div>
                    </div>
                  </div>
                </Col> : item.label === 'applicalbeDaysoftheWeek' ? <Col span={item.span} key={i} className="col-margin">
                  <ApplicalbeDays label="Applicable Days of the Week" readOnly={true} valueList={rowDetail.valueList} ref={applicalbeDaysRef} />
                </Col> : item.label ? <Col span={item.span} key={i} className="col-margin">
                  <DetailItem value={item.value} label={item.label} />
                </Col> : <Col span={item.span} key={i}></Col>
              })
            }
          </Row>
        </Grid>
      </Grid>
    </Card>
  </PageContainer>
  </>
}
export default DetailDetails;
